module.exports = __webpack_public_path__ + "media/daily-express-c51ab5f1.svg";